import React from "react";
import { CheckCircle2 } from "lucide-react";
import { SHOWCASE_BULLETS } from "../../data/constants";

export default function ShowcaseSection() {
  return (
    <section
      id="showcase"
      data-testid="showcase-section"
      className="relative border-b border-white/10 bg-[#0B0F19]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Image */}
          <div className="lg:col-span-7 relative">
            <div className="border border-white/10 overflow-hidden">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/7f72252b-c138-4e30-9fe4-a617a30a0335/images/a01110a8c47a57ccb1fa3a42e4068e66022e0c08b68d09704f761d2b8e925ab9.png"
                alt="Consultant team mapping a digital transformation roadmap"
                className="w-full h-[420px] md:h-[560px] object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden md:block">
              <div className="bg-[#F47B20] text-black p-5 max-w-[240px]">
                <p className="text-[10px] font-bold uppercase tracking-[0.3em]">
                  Our Practice
                </p>
                <p className="font-condensed text-2xl leading-tight mt-2">
                  Strategy + Build + Operate
                </p>
              </div>
            </div>
          </div>

          {/* Checklist */}
          <div className="lg:col-span-5">
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-[#F47B20] mb-4">
              / 02 — What We Do
            </p>
            <h2 className="font-display font-black uppercase tracking-tighter text-white text-4xl sm:text-5xl leading-[0.95] mb-8">
              One team. <br />
              <span className="text-[#F47B20]">Four practices.</span>
            </h2>
            <ul className="border-t border-white/10">
              {SHOWCASE_BULLETS.map((b, idx) => (
                <li
                  key={idx}
                  data-testid={`showcase-bullet-${idx}`}
                  className="flex items-start gap-4 py-5 border-b border-white/10"
                >
                  <CheckCircle2 className="w-5 h-5 text-[#F47B20] flex-shrink-0 mt-1" strokeWidth={2.2} />
                  <p className="text-white/85 text-base md:text-lg leading-snug">{b}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
